


export const layouts = {
'auth-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/auth-layout.vue'),
'navbar-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/navbar-layout.vue'),
'base/document-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/base/document-layout.vue'),
'partials/dashboard-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/partials/dashboard-layout.vue'),
'partials/form-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/partials/form-layout.vue'),
'partials/inbox-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/partials/inbox-layout.vue'),
'partials/investigation-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/partials/investigation-layout.vue'),
'partials/sidebar-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/partials/sidebar-layout.vue'),
'partials/table-dashboard-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/partials/table-dashboard-layout.vue'),
'partials/table-layout': () => import('/builds/developer-core-team/brandefense-prototype/src/layouts/partials/table-layout.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'navbar-layout'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
